<template>
  <div v-if="sign === 'plan'" class="msrpNote fhl">
    <p>a.厂商建议零售价仅为建议，不具有任何约束力。</p>
    <p>b.具体的零售成交价格，由您与选定的授权经销商确定。</p>
  </div>
  <div v-if="sign === 'tyre'" class="msrpNote fhl">
    <p>上述厂商建议零售价仅为单条轮胎价格，不包含动平衡、轮胎拆装工时、轮毂及其他附加价格。</p>
    <!-- <p>其中，基于原厂轮胎套餐厂商建议零售价，动平衡与轮胎拆装工时费*分别约为170元/条及395元/条。</p> -->
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  props: ['sign'],
  setup(props) {
    let { sign } = toRefs(props)
    const state = reactive({
      count: 0,
      sign
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.msrpNote {
  transform: scale(0.95);
  color: #999999;
  margin-left: -8px;
  margin-top: 6px;
  line-height: 1.4;
  text-align: left;
}
</style>
